const STORAGE_KEY = "creditbar-app-banner-hidden-until";
const DAY_MS = 24 * 60 * 60 * 1000;

document.querySelectorAll("[data-app-banner]").forEach((banner) => {
	const closeButton = banner.querySelector("[data-app-banner-close]");

	if (!closeButton) {
		return;
	}

	closeButton.addEventListener("click", () => {
		const hideDays = Number(banner.dataset.appBannerHideDays) || 0;

		banner.hidden = true;

		try {
			window.localStorage.setItem(
				STORAGE_KEY,
				String(Date.now() + hideDays * DAY_MS)
			);
		} catch (e) {
			// localStorage недоступен (приватный режим) — баннер скрыт до перезагрузки.
		}
	});
});
